import { mergeDeep } from '../../utils/general';
import {
  getErrorToPrint as getCommonErrorToPrint,
} from './common';
import {
  getErrorToPrint as getFlowErrorToPrint,
} from './flow';



export const getErrorToPrint = (flowName, userType, isSelfEmployed, goToC2C ) => {

  const ERROR_TO_PRINT = {
    common: {
      ...getCommonErrorToPrint(goToC2C),
    },
    flowSpec: {
      ...getFlowErrorToPrint(goToC2C),
    },
  };

  const commonErrorToPrint = ERROR_TO_PRINT.common;
  let flowCommonErrorToPrint = {};
  let flowNUserTypeErrorPrint = {};
  let flowNSelfEmployedErrorPrint = {};

  if (ERROR_TO_PRINT.flowSpec && ERROR_TO_PRINT.flowSpec[flowName]) {
    if (ERROR_TO_PRINT.flowSpec[flowName].common) {
      flowCommonErrorToPrint = ERROR_TO_PRINT.flowSpec[flowName].common;
    }
    if (ERROR_TO_PRINT.flowSpec[flowName][`user_${userType}`]) {
      flowNUserTypeErrorPrint = ERROR_TO_PRINT.flowSpec[flowName][`user_${userType}`];
    }
    if (isSelfEmployed && ERROR_TO_PRINT.flowSpec[flowName].selfEmployed) {
      flowNSelfEmployedErrorPrint = ERROR_TO_PRINT.flowSpec[flowName].selfEmployed;
    }
  }

  mergeDeep(flowNUserTypeErrorPrint, flowNSelfEmployedErrorPrint);
  mergeDeep(flowCommonErrorToPrint, flowNUserTypeErrorPrint);
  mergeDeep(commonErrorToPrint, flowCommonErrorToPrint);

  return commonErrorToPrint;
};
